<div class="sidebar included">
	<app-sidebar-header [title]="'Shopping Basket'"></app-sidebar-header>
	<div class="sidebar__body sl--scrollable" #sidebar__body *ngIf="selectedFlights?.length">
		<ng-container *ngFor="let selectedFlight of selectedFlights; let index = index">
			<div class="shopping-basket-count border">
				<app-svg class="basket__icon" svg="icons.svg#plane_related--flights" aria-hidden="true" [alt]="'Flight icon'"></app-svg>
				<div class="basket-label">
					<p class="basket-title border">
						{{ selectedFlight.flight.departure.airport.location.city }} -
						{{ selectedFlight.flight.arrival.airport.location.city }}
					</p>
					<div class="basket-price-desc border">
						<p>Fare Difference per adult</p>
						<p class="price-right bold">40,00 €</p>
					</div>
					<div class="basket-price-desc border">
						<p>Penalty per adult</p>
						<p class="price-right bold">140,00 €</p>
					</div>
					<div class="basket-price-desc border">
						<p>Fare Difference per child</p>
						<p class="price-right bold">40,00 €</p>
					</div>
					<div class="basket-price-desc border">
						<p>Penalty per child</p>
						<p class="price-right bold">140,00 €</p>
					</div>
				</div>
			</div>
		</ng-container>
		<div class="basket-price-desc border">
			<div>
				<h3 class="title-h3 basket-total">Total for all passengers</h3>
				<span class="basket-total-desc">Taxes fees and carrier charges included</span>
			</div>
			<p class="price-right bold">140,00 €</p>
		</div>
		<div class="sidebar-flight-text border">
			<p><a class="link extras-feature__link" aria-label="Close dialog" (click)="TAP_handleClose()" href="javascript:;" role="button">Close this
					window</a></p>
		</div>
	</div>
	<div #sidebar__footer class="sidebar__footer "></div>
</div>
